import * as React from "react";

function SvgIcons8FtpServer(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <linearGradient
        id="icons8-ftp_server_svg__a"
        x1={10.517}
        x2={36.546}
        y1={787.122}
        y2={823.141}
        gradientTransform="translate(0 -781.78)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#2aa4f4" />
        <stop offset={1} stopColor="#007ad9" />
      </linearGradient>
      <path
        fill="url(#icons8-ftp_server_svg__a)"
        d="M36 4H12a2 2 0 00-2 2v36a2 2 0 002 2h24a2 2 0 002-2V6a2 2 0 00-2-2z"
      />
      <radialGradient
        id="icons8-ftp_server_svg__b"
        cx={24}
        cy={818.78}
        r={3}
        gradientTransform="translate(0 -781.78)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.582} stopOpacity={0.2} />
        <stop offset={1} stopOpacity={0} />
      </radialGradient>
      <circle cx={24} cy={37} r={3} fill="url(#icons8-ftp_server_svg__b)" />
      <circle cx={24} cy={37} r={2} fill="#fff" />
      <linearGradient
        id="icons8-ftp_server_svg__c"
        x1={14}
        x2={34}
        y1={792.78}
        y2={792.78}
        gradientTransform="translate(0 -781.78)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#1d59b3" />
        <stop offset={1} stopColor="#195bbc" />
      </linearGradient>
      <path
        fill="url(#icons8-ftp_server_svg__c)"
        d="M33.5 14h-19a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h19a.5.5 0 01.5.5v5a.5.5 0 01-.5.5z"
      />
      <circle cx={31} cy={11} r={1} fill="#50e6ff" />
      <linearGradient
        id="icons8-ftp_server_svg__d"
        x1={14}
        x2={34}
        y1={800.78}
        y2={800.78}
        gradientTransform="translate(0 -781.78)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#1d59b3" />
        <stop offset={1} stopColor="#195bbc" />
      </linearGradient>
      <path
        fill="url(#icons8-ftp_server_svg__d)"
        d="M33.5 22h-19a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h19a.5.5 0 01.5.5v5a.5.5 0 01-.5.5z"
      />
      <circle cx={31} cy={19} r={1} fill="#50e6ff" />
      <linearGradient
        id="icons8-ftp_server_svg__e"
        x1={14}
        x2={34}
        y1={808.78}
        y2={808.78}
        gradientTransform="translate(0 -781.78)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#1d59b3" />
        <stop offset={1} stopColor="#195bbc" />
      </linearGradient>
      <path
        fill="url(#icons8-ftp_server_svg__e)"
        d="M33.5 30h-19a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h19a.5.5 0 01.5.5v5a.5.5 0 01-.5.5z"
      />
      <circle cx={31} cy={27} r={1} fill="#50e6ff" />
      <linearGradient
        id="icons8-ftp_server_svg__f"
        x1={38}
        x2={38}
        y1={813.643}
        y2={817.534}
        gradientTransform="translate(0 -781.78)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#eba600" />
        <stop offset={1} stopColor="#c28200" />
      </linearGradient>
      <path
        fill="url(#icons8-ftp_server_svg__f)"
        d="M38.707 33.707l-1.268-1.268a1.499 1.499 0 00-1.06-.439H29a1 1 0 00-1 1v14a1 1 0 001 1h18a1 1 0 001-1V35a1 1 0 00-1-1h-7.586a1 1 0 01-.707-.293z"
      />
      <linearGradient
        id="icons8-ftp_server_svg__g"
        x1={38}
        x2={38}
        y1={815.712}
        y2={829.772}
        gradientTransform="translate(0 -781.78)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#ffd869" />
        <stop offset={1} stopColor="#fec52b" />
      </linearGradient>
      <path
        fill="url(#icons8-ftp_server_svg__g)"
        d="M37.293 35.707l1.634-1.634a.251.251 0 01.177-.073H46c.552 0 2 1.448 2 2v11a1 1 0 01-1 1H29a1 1 0 01-1-1V36.25a.25.25 0 01.25-.25h8.336a1 1 0 00.707-.293z"
      />
      <path
        fill="#a238c2"
        d="M48 38.97v2.01c-.16.01-.33.02-.5.02-3.58 0-6.5-2.92-6.5-6.5 0-.17.01-.34.02-.5h2.01L45 37s2.84 1.99 3 1.97z"
      />
      <path
        fill="#ba54d9"
        d="M48 36.95v2.02c-.16.02-.33.03-.5.03-2.48 0-4.5-2.02-4.5-4.5 0-.17.01-.34.03-.5h2.02c-.03.16.95 2 .95 2l2 .95z"
      />
      <path
        fill="#c767e5"
        d="M48 35v1.951A2.504 2.504 0 0145.049 34H47a1 1 0 011 1z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8FtpServer);
